import ProfilePhoto, { Width } from "../../components/profilePhoto"
import React from "react"
import tw from "twin.macro"
import { getEmojiForReaction } from "."
import { ProfileOnGetProfileFragment, ReactionDetailFragment } from "../../graphql/generated/graphql"
import { Routes } from "../../routes"
import Link from "next/link"

interface ReactionProps {
  emoji: string
  Reactor: ProfileOnGetProfileFragment
}

const Reaction = ({ emoji, Reactor }: ReactionProps) => {
  const { profilePictureUrl, username, name, verified } = Reactor
  return (
    <li tw="py-2 flex items-center justify-between">
      <Link href={{ pathname: Routes.Profile, query: { username: username } }} passHref>
        <div tw="flex space-x-2 items-center hover:(cursor-pointer)">
          <div tw="inline-block">
            <ProfilePhoto profilePictureUrl={profilePictureUrl} width={Width.W30} showVerified={verified} />
          </div>
          <div tw="flex flex-col">
            <p tw="text-xs font-bold text-base-4">{username}</p>
            <p tw="text-xs text-base-4">{name}</p>
          </div>
        </div>
      </Link>
      <div tw="text-xl">{getEmojiForReaction(emoji)}</div>
    </li>
  )
}

interface AllReactionsProps {
  reactions: ReactionDetailFragment[]
}

export const AllReactions = ({ reactions }: AllReactionsProps) => {
  return (
    <div tw="space-y-2" css={[tw`mobile-lg:(w-[260px])`]}>
      <h4 tw="text-center">Reactions</h4>
      <ul tw="divide-y-2 divide-base-2">
        {reactions.map((item: ReactionProps) => {
          const { emoji, Reactor } = item
          return <Reaction key={Reactor.id} emoji={emoji} Reactor={Reactor} />
        })}
      </ul>
    </div>
  )
}
